import { Box, DialogActions, DialogContent, DialogTitle, MenuItem, Select, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ContainedButton from 'shared/components/Buttons/ContainedButton'
import OutlinedButton from 'shared/components/Buttons/OutlinedButton'
import CustomDialog from 'shared/components/CustomDialog'
import { useNotificationContext } from 'shared/context/Notifications'
import { CategoriesType, CategoryType } from 'shared/store/useCategories/types'
import { useSettingsQuery } from 'shared/store/useSettings'
import { changeCategoryService } from 'views/Authorized/views/ProductDetails/services'

interface Props {
   open: boolean
   onClose: () => void
   productUuid: string
   categories: CategoriesType
   currCategoryUuid: string
}

export default function ChangeCategoryModal({ open, onClose, categories, currCategoryUuid, productUuid }: Props) {
   const [category, setCategory] = useState(currCategoryUuid || '')
   const { data: user } = useSettingsQuery()
   const { addNotification } = useNotificationContext()
   const [isLoading, setIsLoading] = useState(false)
   const [searchPhrase, setSearchPhrase] = useState('')

   function flattenCategories(categoriesArray: CategoryType[], depth = 0): Array<CategoryType & { depth: number }> {
      return categoriesArray.flatMap((cat) => [{ ...cat, depth }, ...flattenCategories(cat.children || [], depth + 1)])
   }

   const flatCategories = flattenCategories(categories.categories)

   function handleSubmit() {
      setIsLoading(true)
      changeCategoryService(productUuid, {
         uuid: category,
         source: user!.userSettings.email!,
         sourceValue: '',
      })
         .then((res) => {
            if (res.status === 204) {
               addNotification('Pomyślnie zapisano zmiany', 'success')
               onClose()
               setTimeout(() => window.location.reload(), 1500)
            }
         })
         .catch(() => {
            addNotification(`Wystąpił problem podczas zapisywania`, 'error')
         })
         .finally(() => setIsLoading(false))
   }

   function renderDepth(depth: number) {
      const arrow = '- '
      if (depth === 0) {
         return ''
      }
      return `${arrow.repeat(depth)}>`
   }

   useEffect(() => {
      if (currCategoryUuid) {
         setCategory(currCategoryUuid)
      }
   }, [currCategoryUuid])

   return (
      <CustomDialog
         open={open}
         isLoading={!productUuid}
         onClose={onClose}
         content={
            <>
               <DialogTitle>Edycja kategorii produktu</DialogTitle>
               <DialogContent>
                  <Select
                     MenuProps={{
                        PaperProps: {
                           style: { maxHeight: '350px' },
                        },
                     }}
                     hiddenLabel
                     fullWidth
                     value={category}
                     onChange={(e) => setCategory(e.target.value)}
                  >
                     <Box sx={{ backgroundColor: 'white', p: '6px 4px' }}>
                        <TextField
                           variant="standard"
                           sx={{ width: '80%', ml: 3 }}
                           defaultValue={searchPhrase}
                           placeholder="Szukaj"
                           onKeyDown={(e) => e.stopPropagation()}
                           onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                           }}
                           onFocus={(e) => e.target.select()}
                           onChange={(e) => {
                              setSearchPhrase(e.target.value)
                           }}
                        />
                     </Box>
                     {flatCategories
                        .filter((item) => item.name.toLowerCase().includes(searchPhrase.toLowerCase()))
                        .map((item) => (
                           <MenuItem key={item.uuid} value={item.uuid} disabled={item.children.length > 0}>
                              {`${renderDepth(item.depth)} ${item.name}`}
                           </MenuItem>
                        ))}
                  </Select>
               </DialogContent>
               <DialogActions>
                  <OutlinedButton onClick={onClose}>Anuluj</OutlinedButton>
                  <ContainedButton disabled={isLoading} onClick={handleSubmit}>
                     Zapisz
                  </ContainedButton>
               </DialogActions>
            </>
         }
      />
   )
}
